<template>
  <div>
    <page-breadcrumb :title="pageTitle" :routes="routes" />
    <vx-card v-if="datas.length > 0">
      <video-player :options="videoOptions" />
    </vx-card>
  </div>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer.vue";
import PageBreadcrumb from "../components/PageBreadcrumb.vue";
import api from "../api";

import "video.js/dist/video-js.css";

export default {
  data() {
    return {
      pageTitle: "",
      datas: [],
      videoOptions: {
        autoplay: true,
        controls: true,
        fluid: true,
        aspectRatio: "9:16",
        sources: [
          {
            src: "",
            type: "video/mp4",
          },
        ],
      },
    };
  },
  computed: {
    currentSite() {
      return this.$store.state.currentSite;
    },
    currentArea() {
      return this.$store.state.currentArea;
    },
    routes() {
      return {
        ...this.$route,
        meta: {
          ...this.$route.meta,
          breadcrumb: [
            { title: "Dashboard", url: "/" },
            {
              title: this.currentSite.name,
              url: "/site/" + this.currentSite.id,
            },
            {
              title: this.currentArea.name,
              url: "/site/" + this.currentSite.id + "/" + this.currentArea.id,
            },
          ],
        },
      };
    },
  },
  components: {
    VideoPlayer,
    PageBreadcrumb,
  },
  created() {
    this.$vs.loading();
    this.getCameraView();
  },
  methods: {
    getCameraView() {
      api
        .cameraView({ Id: this.$route.params.id })
        .then((result) => result.data.data)
        .then((data) => {
          this.datas = data;
          this.videoOptions.sources[0].src = data[0]["liveStreamUrl"];
          this.pageTitle = data[0].name;
          this.$vs.loading.close();
          this.routes.meta.breadcrumb.push({
            title: data[0].name,
            active: true,
          });
        });
    },
  },
};
</script>
